var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('section',{attrs:{"id":"adaptive"}},[_c('span',{domProps:{"innerHTML":_vm._s(_vm.mdfile)}}),_c('img',{staticClass:"img-fluid rounded",attrs:{"src":require("@/assets/gel/site-images/adaptive.gif"),"alt":"adaptive"}})])}
var staticRenderFns = []

export { render, staticRenderFns }